import { t } from "i18next";
import { Button, Form, Modal } from "react-bootstrap";
import { createTrainingSession } from "../../../../services/training-session";
import { useState } from "react";
import { TrainingSessionTpl } from "../../../../interfaces/training-session-tpl";
import { getTrainingSessionTplOptions } from "../../../../services/training-session-tpl";
import { ColorSelector } from "../../../general/color-selector";

interface CoachTrainingSessionNewProps {
    onSave: CallableFunction;
    onClose: CallableFunction;
}

export function CoachTrainingSessionNew(props: CoachTrainingSessionNewProps) {
    const [source, setSource] = useState('scratch');
    const [templates, setTemplates] = useState<TrainingSessionTpl[]>([]);
    const [color, setColor] = useState('#34B689');
    
    const handleSave = (event: any) => {
        event.preventDefault();

        let date_time = '';
        if (event.target.date_part.value.length > 0) {
            date_time = event.target.date_part.value;
            if (event.target.time_part.value.length > 0) {
                date_time += ' ' + event.target.time_part.value + ':00'; 
            }
        }

        let template_id = 0;
        if (source == 'template') {
            template_id = event.target.template_id.value;
        }

        const body = {
            name: event.target.name.value,
            description: event.target.description.value,
            goals: event.target.goals.value,
            date_time: date_time,
            source: source,
            template_id: template_id,
            color: color
        }
        createTrainingSession(body)
            .then(response => {
                if (response.data.status == 1) {
                    props.onSave(response.data.data);
                } else {
                    alert(response.data.message);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }
    
    const handleClose = () => {
        props.onClose();
    }

    const handleSourceChange = (event: any) => {
        setSource(event.currentTarget.value);
        if (event.currentTarget.value == 'template') {
            getTrainingSessionTplOptions()
            .then((response: any) => {
                setTemplates(response.data.map((t: TrainingSessionTpl) => {
                    return {
                        value: t.id,
                        label: t.name
                    }
                }));
            });
        } else {
            setTemplates([]);
        }
    }

    const handleSetColor = (color: string) => {
        setColor(color);
    }

    return (
        <Modal className="training-session-new-container" show={ true }
            onHide={ handleClose } size="lg"> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("new_training_session") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={ handleSave }>
                    <div className="fields">
                        <fieldset className="source mb-3">
                            <legend>{ t("message_template_source") }</legend>
                            <div className="fildset-content">
                                <Form.Check
                                    inline
                                    label={ t("from_scratch") }
                                    name="fromTemplate"
                                    type={ 'radio' }
                                    value={ 'scratch' }
                                    defaultChecked = { source == 'scratch' }
                                    onChange={ handleSourceChange }
                                />
                                <Form.Check
                                    inline
                                    label={ t("from_template") }
                                    name="fromTemplate"
                                    type={ 'radio' }
                                    value={ 'template'}
                                    defaultChecked = { source == 'template' }
                                    onChange={ handleSourceChange }
                                />
                                { source == 'template' &&
                                     <Form.Select name="template_id" aria-label={ t("template")} className="mt-3" required>
                                        <option value="">{ t("select_template") }</option>
                                        { templates.map((t: any) => {
                                            return <option key={ 'template-' + t.value } value={ t.value }>{ t.label }</option>
                                        })}
                                    </Form.Select>
                                }
                            </div>
                        </fieldset>
                        <Form.Group className="mb-3" controlId="name">
                            <Form.Label aria-required="true">{ t("Name") }</Form.Label>
                            <Form.Control type="text" name="name" required />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="description">
                            <Form.Label>{ t("description") }</Form.Label>
                            <Form.Control name="description" as="textarea" rows={5} />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="goals">
                            <Form.Label>{ t("goals") }</Form.Label>
                            <Form.Control name="goals" as="textarea" rows={5} />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="color">
                            <Form.Label>{ t("color") }</Form.Label>
                            <ColorSelector setColor={ handleSetColor } defaultColor={ color } />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="date_time">
                            <Form.Label>{ t("date_time") }</Form.Label>
                            <div className="date-time-container">
                                <Form.Control name="date_part" type="date" />
                                <Form.Control name="time_part" type="time" />
                            </div>
                        </Form.Group>
                    </div>
                    <div className="actions">
                        <Button type="submit" variant="primary">
                            { t("Save") }
                        </Button>
                        <Button variant="secondary" onClick={ handleClose }>
                            { t("Close") }
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
}
